<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="image-wrapper_1 flex-row">
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNG27fc4de38f3da283fec465472e8ec088.png"
          @click="this.$router.push('/')"
        />
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNG43ad45b74447ebb4b199810652205b1a.png"
          @click="this.$router.push('/')"
        />
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNGc066228afdb3fa95d76d5da2908022cf.png"
          @click="scrollIntoView('image_13', 50)"
        />
        <img
          class="image_4"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNG42043f770e041a69238596db9ed31e3d.png"
          @click="scrollIntoView('image-wrapper_5', -90)"
        />
        <img
          class="image_5"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNG64c558e9a9ad172b2af7d68e1f1a3ff5.png"
          @click="scrollIntoView('image_23', 0)"
        />
        <img
          class="image_6"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNGd8bf1e20c7b6e772f8e5ccecbddfbb1f.png"
          v-if="isLogin"
          @click="CreateGame"
        />
        <img
          class="image_7"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNGa64dcce95d08f3ad71a07ae9245cbebc.png"
          v-if="!isLogin"
          @click="this.$router.push('/login')"
        />
        <el-dropdown
          show-timeout="0"
          hide-timeout="50"
          size="large"
          v-if="isLogin"
          class="detail"
        >
          <el-avatar :src="userInfo.avatar" class="avatar" />
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="cn"
                ><a>{{ userInfo.name }}</a></el-dropdown-item
              >
              <el-dropdown-item command="cn" @click="this.$router.push('/list')"
                ><a>{{ $t("home.list") }}</a></el-dropdown-item
              >

              <el-dropdown-item
                command="en"
                @click="this.$router.push('/setting')"
                ><a>{{ $t("home.Setting") }}</a></el-dropdown-item
              >
              <el-dropdown-item command="jp" @click="logout"
                ><a>{{ $t("home.logout") }}</a></el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-dropdown
          show-timeout="0"
          hide-timeout="50"
          @command="handleCommand"
        >
          <img
            class="image_8"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG94348678cb761fe7841c6a58913e543e.png"
          />
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="cn">简体中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
              <el-dropdown-item command="jp">繁体中文</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div class="image-wrapper_2 flex-row">
        <img
          class="image_9"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNG14bf3e51dc2bc842d003a66311eada9a.png"
        />
      </div>
      <img
        class="image_10"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNG98dbb9ea6409f0c53bd1fb85afe2a97d.png"
      />
    </div>
    <div class="group_2 flex-col">
      <img
        class="image_11"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNG3a12e0f2635947659637dd09531c1c59.png"
      />
      <div class="image-wrapper_3 flex-row">
        <img
          class="image_12"
          referrerpolicy="no-referrer"
          :src="item.lanhuimage0"
          v-for="(item, index) in loopData0"
          :key="index"
        />
      </div>
      <img
        class="image_13"
        id="image_13"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNG60b21620bd0dede6c3bb1836f2729bed.png"
      />
      <img
        class="image_14"
        id="image_14"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNGeaae2eb049353843bcf1849bbbe1ada2.png"
        @click="changeRouter"
      />
      <img
        class="image_15"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNG0097e65f58326c976050f849896ea617.png"
        @click="changeRouter"
      />
      <img
        class="image_16"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNG78fa3003223c56b5d2869e7732b54dcc.png"
        @click="changeRouter"
      />
      <img
        class="image_17"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNG0ad6a3e6946024a2492f26967a95d733.png"
        @click="changeRouter"
      />
    </div>
    <div class="group_3 flex-col">
      <img
        class="image_18"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNGf5947b65b87fa10793926bda3bff2f85.png"
      />
      <div class="image-wrapper_4 flex-row justify-between">
        <img
          class="image_19"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNGc5ce9d26733c4584997d7b69dab1179d.png"
        />
        <img
          class="image_20"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNG112c5b5f54d864828cc6db0f6368b751.png"
        />
      </div>
    </div>
    <div class="image-wrapper_5 flex-col" id="image-wrapper_5">
      <img
        class="image_21"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNGee9662e52387d993b4deb648bac50345.png"
      />
      <img
        class="image_22"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNGa8df8aa575b03512e329b083a3b2a65e.png"
      />
    </div>
    <div class="group_4 flex-col">
      <img
        class="image_23"
        id="image_23"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNGbeec428229cbc97454fbf3a9e1b4371e.png"
      />
      <img
        class="image_24"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNG891c1bf8bcdb225465d85da7fc7f4d43.png"
      />
      <img
        class="image_25"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNGb64c766c5ef62f077b8b46bb11c8242e.png"
      />
      <div class="image-wrapper_6 flex-row justify-between">
        <a
          href="https://apps.apple.com/cn/app/mapgame/id6740665605"
          target="_blank"
        >
          <img
            class="image_26"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG82395ff4bed5e655603171961b5e9e07.png"
          />
        </a>
        <a href="https://www.pgyer.com/chufaba-android" target="_blank">
          <img
            class="image_27"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGa0d2bef56929ed042e0b2d75ede5b23f.png"
          />
        </a>
      </div>
      <img
        class="image_28"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNGcee76738026af3d147309aced79ca890.png"
      />
      <img
        class="image_29"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNGaded519179c2e1660c49616bf109a537.png"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { Data2 } from "@/views/view";
import { getToken } from "@/utils/auth";
import { ElMessage, ElMessageBox } from "element-plus";

export default defineComponent({
  name: "App",
  data(): any {
    return {
      title: "欢迎来到Vue 3页面模版",
      counter: 0,
      message: "",
      data: null,
      loading: false,
      error: "",
      boxRef: null,
      isLogin: getToken() != undefined,
      loopData0: [
        {
          lanhuimage0:
            "https://lanhu-oss.lanhuapp.com/FigmaDDSSlicePNGe09eddf36f0a24528f8fb3fcc54e6c6a.png",
        },
        {
          lanhuimage0:
            "https://lanhu-oss.lanhuapp.com/FigmaDDSSlicePNGfcdc7432561c1ac555fe1bbf0b6b107c.png",
        },
        {
          lanhuimage0:
            "https://lanhu-oss.lanhuapp.com/FigmaDDSSlicePNG177cdbca2ca2d5f95b2de917e120f514.png",
        },
        {
          lanhuimage0:
            "https://lanhu-oss.lanhuapp.com/FigmaDDSSlicePNG2b24190a9a2a7867cc68d018981ce6e2.png",
        },
        {
          lanhuimage0:
            "https://lanhu-oss.lanhuapp.com/FigmaDDSSlicePNG13bd386adc6a939a411f23fc876c1677.png",
        },
        {
          lanhuimage0:
            "https://lanhu-oss.lanhuapp.com/FigmaDDSSlicePNG175f583226276a4daf9d414a0df71404.png",
        },
      ],
      constants: {},
    };
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    userInfo(): any {
      return this.$store.state.user;
    },
  },
  watch: {
    counter(newVal: number, oldVal: number) {
      console.log(`Counter changed from ${oldVal} to ${newVal}`);
    },
    message(newVal: string, oldVal: string) {
      console.log(`Message changed from "${oldVal}" to "${newVal}"`);
    },
  },
  mounted() {
    switch (this.$route.params.id) {
      case "1":
        this.scrollIntoView("image_13", 50);
        break;
      case "2":
        this.scrollIntoView("image-wrapper_5", -90);
        break;
      case "3":
        this.scrollIntoView("image_23", 0);
        break;
      default:
        break;
    }
  },
  methods: {
    handleCommand(command: string) {
      this.$i18n.locale = command;
      localStorage.setItem("lang", command);
    },
    logout() {
      this.$store
        .dispatch("user/logout")
        .then(() => {
          localStorage.clear();
          this.$router.push("/login");
        })
        .catch(() => {
          console.log("failed to log out");
        });
    },
    CreateGame() {
      const type = this.$store.state.user.type;

      if (type == "体验者") {
        ElMessageBox.confirm("体验者不能创建游戏，是否申请为创作者?", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store
              .dispatch("game/applyCreate")
              .then((res2: any) => {
                console.log(res2);
              })
              .catch((err: any) => {});
          })
          .catch(() => {});
      } else {
        const userId = this.$store.state.user.Id;
        const pageSize = 10;
        const status = 0;
        this.$store
          .dispatch("game/createGame")
          .then((res: any) => {
            this.$store
              .dispatch("game/getGameList", {
                pageNum: 1,
                pageSize: pageSize,
                userId: userId,
                status: status,
              })
              .then((res2: any) => {
                this.$router.push("/edit/" + res.id + "/cover");
              });
          })
          .catch((err: any) => {});
      }
    },
    scrollIntoView(target, offset) {
      const targetElem = document.getElementById(target);

      // 获取目标元素的垂直偏移量
      const targetElemPosition = targetElem.offsetTop;

      // 计算需要滚动的位置，提前 100px 滚动
      const targetPositionWithOffset = targetElemPosition - offset;

      // 判断浏览器是否支持 `scroll-behavior: smooth`
      if (
        typeof window.getComputedStyle(document.body).scrollBehavior ==
        "undefined"
      ) {
        // 当前滚动的高度
        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;

        // 自定义滚动的步进函数
        const step = function () {
          // 计算当前到目标的距离
          let distance = targetPositionWithOffset - scrollTop;

          // 每次滚动五分之一的距离
          scrollTop = scrollTop + distance / 5;

          if (Math.abs(distance) < 1) {
            window.scrollTo(0, targetPositionWithOffset); // 滚动到目标位置
          } else {
            window.scrollTo(0, scrollTop); // 继续滚动
            setTimeout(step, 20); // 设置下一个滚动步进
          }
        };
        step(); // 启动滚动动画
      } else {
        // 浏览器支持平滑滚动，直接使用 scrollTo 来设置滚动
        window.scrollTo({
          top: targetPositionWithOffset,
          behavior: "smooth", // 平滑滚动
        });
      }
    },
    changeRouter() {
      let routeData = this.$router.resolve({
        path: "/about",
      });
      window.open(routeData.href, "_blank");
    },
  },
});
</script>
<style scoped lang="less" src="./assets/index.response.less" />
